let utils = {
  // https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
  id() {
    let t = Date.now();

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (t + (Math.random() * 16)) % 16 | 0;

      t = Math.floor(t / 16);

      return (c === "x" ? r : ((r & 0x3) | 0x8)).toString(16);
    });
  },

  clone(obj) {
    // ugh
    return JSON.parse(JSON.stringify(obj));
  },

  prune(obj, keys) {
    let copy = {};

    keys.forEach(function (k) {
      copy[k] = obj[k];
    });

    return copy;
  },

  hash(arr, key) {
    let obj = {};

    arr.forEach(function (o) {
      obj[o[key]] = o;
    });

    return obj;
  },

  filter(list, fields, term) {
    let t = term.trim().toLowerCase().replace(/[\\,]/g, "");

    if (t.length) {
      return list.filter(function (item) {
        let s = fields.reduce((a, b) => a + (item[b] || ""), "").toLowerCase();

        return !!t.split(/\s+/).every((t) => s.indexOf(t) > -1);
      });
    }

    return list;
  },

  flatten(list) {
    // eslint-disable-next-line prefer-spread
    return Array.prototype.flat ? list.flat() : [].concat.apply([], list);
  },

  bisect(list, accessor) {
    let i = list.findIndex(accessor);

    if (i > -1) {
      return [
        list.slice(0, i),
        list.slice(i + 1)
      ];
    }

    return [[], []];
  },

  page(list, accessor) {
    let [a, b] = this.bisect(list, accessor);

    return [
      a.length ? a[a.length - 1] : null,
      b.length ? b[0] : null
    ];
  },

  distinct(list) {
    if (Array.from) {
      return Array.from(new Set(list));
    }

    // IE 11
    let result = [];

    list.forEach(function (item) {
      if (result.indexOf(item) === -1) {
        result.push(item);
      }
    });

    return result;
  },

  equals(a, b) {
    return Object.keys(b).every(function (key) {
      return a[key] === b[key];
    });
  },

  sortIgnoreCase(accessor) {
    return function (a, b) {
      return accessor(a).toLowerCase() > accessor(b).toLowerCase() ? 1 : -1;
    };
  },

  chain(commands) {
    let chain = Promise.resolve();
    let sequence = [].concat(commands);

    if (sequence.length) {
      chain = sequence.shift().call();

      while (sequence.length) {
        chain = chain.then(sequence.shift());
      }
    }

    return chain;
  }
};

module.exports = utils;